/** 头像只取姓名首字 */
export function shortName(name) {
  return String(name || '会').slice(0, 1);
}

/** 风险徽标颜色：low 绿 / medium 黄 / high 红，无报告为灰 */
export function riskClass(level) {
  if (level === '高风险' || level === 'high') return 'is-high';
  if (level === '中风险' || level === '中等风险' || level === 'medium') return 'is-mid';
  if (!level || level === '无报告') return 'is-none';
  return 'is-low';
}

/**
 * 指标等级颜色
 * level：1 正常(绿) 2 临界 / 3 偏高 / 4 不足(黄) 0 或 noData 无数据(灰)
 */
export function indicatorClass(item) {
  if (!item || item.noData || item.level === 0) return 'is-none';
  if (item.level === 1) return 'is-ok';
  return 'is-warn';
}

/** 依从性进度条宽度，限制在 0-100 */
export function adhereWidth(value) {
  const num = parseInt(value, 10);
  if (Number.isNaN(num)) return '0%';
  return `${Math.max(0, Math.min(num, 100))}%`;
}
